var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"center center\" layout-padding=\"layout-padding\" class=\"detailHeader\"><div flex=\"75\" layout=\"row\" layout-align=\"start center\"> <ellipsis-title title=\"vm.detailTitle\" char-size=\"50\"></ellipsis-title><md-button ng-repeat=\"(key, val) in vm.detailBtns\" ng-click=\"vm.buttonHandler(val)\" aria-label=\"close\" class=\"md-raised\">{{val.label}}</md-button></div><div flex=\"25\" layout=\"row\" layout-align=\"end center\"> <md-button ng-click=\"vm.close()\" aria-label=\"close\"><span class=\"glyphicon glyphicon-remove\"></span></md-button></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/common/widgets/detailHeader.jade
// module id = 530
// module chunks = 0